import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from "@angular/core";
import { provideRouter, RouteReuseStrategy } from "@angular/router";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { routes } from "./app.routes";
import { environment } from "src/environments/environment";
import {
  AutoRefreshTokenService,
  UserActivityService,
  withAutoRefreshToken,
  provideKeycloak,
  createInterceptorCondition,
  IncludeBearerTokenCondition,
  includeBearerTokenInterceptor,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG
} from 'keycloak-angular';

const urlCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
  urlPattern: new RegExp(`^${environment.API_BASE_PATH}(/(?!v1/public/).*)?$`, 'i'),
  bearerPrefix: 'Bearer'
});

import { BASE_PATH } from "./services/api/bi-service/variables";
import { provideEchartsCore } from "ngx-echarts";
import { RealEstateRouteReuseStrategy } from "./pages/real-estate/real-estate-route-reuse.strategy";

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    { provide: RouteReuseStrategy, useClass: RealEstateRouteReuseStrategy },
    provideHttpClient(withInterceptors([includeBearerTokenInterceptor])),
    provideEchartsCore({
      echarts: () => import("echarts"),
    }),
    { provide: BASE_PATH, useValue: environment.API_BASE_PATH },
    provideKeycloak({
      config: {
        url: environment.keycloak.config.url,
        realm: environment.keycloak.config.realm,
        clientId: environment.keycloak.config.clientId,
      },
      initOptions: {
        onLoad: "check-sso",
        checkLoginIframe: false,
        redirectUri: window.location.href,
      },
      features: [
        withAutoRefreshToken({
          // Idle users keep their session; the bearer interceptor refreshes the token on the next request.
          onInactivityTimeout: "none",
          sessionTimeout: 1800000,
        }),
      ],
      providers: [AutoRefreshTokenService, UserActivityService],
    }),
    {
      provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
      useValue: [urlCondition]
    },
  ],
};
